import request from './request.js';
import {requestbody} from './request.js'
// 报告列表分页查询
export async function reportingpage (params = {
}) {
return await requestbody('/reporting/page', 'post', params)
}
// 查看报告明细
export async function reportinggetOne (params = {
}) {
return await request('/reporting/getOne', 'post', params)
}
// 获取所有公司列表
export async function getAllCompanys (params = {
}) {
return await request('/sys/getAllCompanys', 'post', params)
}
// 生成报告
export async function reportinggenerate (params = {
}) {
return await requestbody('/reporting/generate', 'post', params)
}
// 保存报告和报告明细
export async function saveReporting (params = {
}) {
return await requestbody('/reporting/saveReporting', 'post', params)
}
// 删除报告和报告明细
export async function delReporting (params = {
}) {
return await requestbody('/reporting/delReporting', 'post', params)
}